module.exports = __webpack_public_path__ + "img/ic-compare.e5c55b13.svg";